import React from "react";
import {withRouter} from "react-router-dom";
import {confirmAlert} from "react-confirm-alert";
import Button from "../Button";
import {undoProjectStatus} from "../../api";
import {isCreatorOrAdministrator} from "../../components/UndoPopUp";
import Alert from "../Alert";

export default withRouter(function UndoPopUp(props) {

    const {project,undoStatus,history,context,id, style} = props;
    // const [status,setStatus] = useState(true);

        async function undoStatusById(project) {
            const result = await undoProjectStatus(project);
            //checking release projects for Approved or waiting for responses exceptions
            if(project.projectStatus && project.projectStatus === 'R' && result === 'PREFORM_EXCEPTION_DELETE_ERROR')
            {
                PreFormExceptionDeleteError();
                return;
            }
            if (result !== "Undo") {
                InvalidDataConfirm();
            }
            else {
                if (project.projectStatus && project.projectStatus === 'N') {
                    history.push(`/development/${project.id}`);
                } else {
                    history.push(`/`);
                    context.setActiveDashboardTab(getActiveDashboardTab(project));
                }
            }
        }

        function getActiveDashboardTab(project) {
            switch (project.projectStatus) {
                case 'D':
                    return 'U';
                case 'R':
                    return 'D';
                case 'A':
                    return 'R';
                case 'N':
                    return 'D';
                case 'C':
                    return 'A';
            }
        }

   function InvalidDataConfirm ()  {
        let msg = "Undo Status was not properly done...";
        confirmAlert({
            customUI: ({onClose}) => {
                return (
                    <Alert msg={msg} onClose={onClose} />
                );
            }
        });
    };

    function PreFormExceptionDeleteError()  {
        let msg = "This project has either Energized Pre-E Form or an Exception has been Approved or is Waiting on Responses. " +
            "You cannot move this back to In-Development. Please contact Checklist Support to delete this exception and/or Pre-E form if necessary.";
        confirmAlert({
            customUI: ({onClose}) => {
                return (
                    <Alert msg={msg} onClose={onClose} />
                );
            }
        });
    };

    function statusConfirm(project) {
            confirmAlert({
                customUI: ({onClose}) => {
                    return (
                        <div className="react-confirm-alert-body">
                            {(() => {
                                    switch (project.projectStatus) {
                                        case 'D':
                                            return <p> Are you sure you want to move {project.stationName} from
                                                In-Development to Upcoming status  </p>
                                        case 'R':
                                            return <p> Are you sure you want to move {project.stationName} from
                                                Released to In-Development status? Doing this will erase all tasks and forms created for the project.</p>
                                        case 'A':
                                            return <p> Are you sure you want to move {project.stationName} from
                                                Active to Released status </p>
                                        case 'N':
                                            return <p> Are you sure you want to move {project.stationName} from
                                                Checklist N/A to In-Development status </p>
                                        case 'C':
                                            return <>
                                                <p> Are you sure you want to move {project.stationName} from
                                                Closed to Active status </p><br/>
                                                <p> <u>CAUTION</u>: If any data changes cause an asset to be flagged as <b>Verify IPS Data</b>,
                                                    you will not be able to return the project to the Closed status until the data is
                                                    reverted in the source system!  </p>
                                            </>
                                        default:
                                            return null;
                                    }
                                }
                            )()}
                            <br/>
                            <div className="btn start-2">
                                <Button className="btn btn-primary start-5" onClickHandler={onClose}>
                                    No
                                </Button>

                                {"           "}
                            </div>
                            <div className="btn start-2">
                                <Button
                                    className="btn btn-primary start-5"
                                    onClickHandler={() => {
                                        undoStatusById(project);
                                        onClose();
                                    }}
                                >
                                    Yes
                                </Button>
                            </div>
                        </div>

                    );

                }
            });
        }
    return(
        <div style={style}>
            {(project.projectStatus !== 'N') &&
            <Button
                id={"undo-project"}
                onClickHandler={() => statusConfirm(project)}>
                {undoStatus}
            </Button>
            }
            {(project.projectStatus === 'N') &&
            <Button
                id={'cardEditLink' + project.id}
                classStyle={"ant-btn ant-btn-link"}
                onClickHandler={() => statusConfirm(project)}>
                {undoStatus}
            </Button>
            }
        </div>
          )

})